import React from 'react';
import './AppBar.css';
import {
    Flex,
    IconButton,
    Text
} from '@radix-ui/themes';
import {
    HamburgerMenuIcon
} from '@radix-ui/react-icons';
import logo from '../logo.png';
import StudentSwitcher from './StudentSwitcher';
import { Member } from '../services/api';

interface AppBarProps {
    onMenuClick: () => void;
    students: Member[];
    selectedStudent: Member | null;
    onStudentChange: (student: Member) => void;
}

const AppBar: React.FC<AppBarProps> = ({
    onMenuClick,
    students,
    selectedStudent,
    onStudentChange
}) => {
    return (
        <header className="app-bar">
            <Flex align="center" justify="between" className="app-bar-content">
                {/* Left side - Menu and Logo */}
                <Flex align="center" gap="3">
                    <IconButton
                        variant="ghost"
                        onClick={onMenuClick}
                        className="menu-button"
                    >
                        <HamburgerMenuIcon width="20" height="20" />
                    </IconButton>

                    <Flex align="center" gap="2" className="logo-section">
                        <img src={logo} alt="Logo" className="app-logo" />
                        <Text size="3" weight="bold" className="app-title">
                            Wado Kai Karate-Ka Space
                        </Text>
                    </Flex>
                </Flex>

                {/* Right side - Student Switcher */}
                <Flex align="center" gap="3">
                    <StudentSwitcher
                        students={students}
                        selectedStudent={selectedStudent}
                        onStudentChange={onStudentChange}
                        isDarkTheme={false}
                    />
                </Flex>
            </Flex>
        </header>
    );
};

export default AppBar; 